import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useMemo, useState } from 'react';
import styled from '@xstyled/styled-components';
import { Row, Col, Switch } from 'antd';
import { NumberInput, SingleSelectInput, getSize, getColor } from '@lib/common';
import { TimeUnit, SpeakingMaxAttempts, SpeakingMinAnswerDuration } from '@module/form';
import Image from 'next/image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var toNumberInputValue = function toNumberInputValue(value) {
  if (value === null || value === '') return '';
  var parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : '';
};

var StyledCard = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n"])), getColor('fillBgSub'), getColor('shapeBorder'), getSize('radiusS'), getSize('padding20'), getSize('padding16'), getSize('padding16'));
var StyledHeader = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding-bottom: ", ";\n  margin-bottom: ", ";\n  border-bottom: 1px solid ", ";\n"])), getSize('padding8'), getSize('padding12'), getSize('padding16'), getColor('shapeBorder'));
var StyledTitle = styled.h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: ", ";\n  font-weight: 700;\n  color: ", ";\n"])), getSize('typo16'), getColor('contentHeading'));
var FieldLabel = styled.label(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  margin: 0;\n"])), getSize('typo14'), getColor('contentBody'));
var LabelRow = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: ", ";\n"])), getSize('padding8'));
var SwitchLabelWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  font-size: 13px;\n  color: ", ";\n  font-weight: 500;\n"])), getSize('padding8'), getColor('contentBody'));
var DashedPlaceholderBox = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 40px;\n  padding: 0 ", ";\n  background-color: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", ";\n  font-size: ", ";\n  color: ", ";\n  font-weight: 500;\n"])), getSize('padding12'), getColor('fillBgWhite'), getColor('shapeBorder'), getSize('radiusS'), getSize('typo14'), getColor('contentBody'));
var StyledErrorMessage = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-top: 4px;\n  font-size: 12px;\n  color: ", ";\n  font-weight: 500;\n"])), getColor('errorActive'));
var StyledInputGroup = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  overflow: hidden;\n  transition: all 0.2s ease-in-out;\n\n  &:hover,\n  &:focus-within {\n    border-color: ", ";\n  }\n\n  .ant-input-number {\n    flex: 1;\n    width: 100%;\n    border: none !important;\n    box-shadow: none !important;\n\n    .ant-input-number-input {\n      height: 40px;\n      padding: 0 ", ";\n      font-size: ", ";\n      color: ", ";\n      font-weight: 500;\n    }\n  }\n\n  .ant-select {\n    width: 100px;\n    border-left: 1px solid ", ";\n\n    .ant-select-selector {\n      border: none !important;\n      box-shadow: none !important;\n      background: transparent !important;\n      height: 40px !important;\n      display: flex;\n      align-items: center;\n\n      .ant-select-selection-item {\n        font-size: ", ";\n        font-weight: 500;\n        color: ", ";\n        line-height: 40px !important;\n      }\n    }\n  }\n"])), getColor('fillBgWhite'), function (_ref) {
  var $error = _ref.$error;
  return $error ? getColor('errorActive') : getColor('shapeBorder');
}, getSize('radiusS'), function (_ref2) {
  var $error = _ref2.$error;
  return $error ? getColor('errorActive') : getColor('fillIntActive');
}, getSize('padding12'), getSize('typo14'), getColor('contentHeading'), getColor('shapeBorder'), getSize('typo14'), getColor('contentBody'));
var StyledSuffixWrapper = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 40px;\n  background-color: ", ";\n  border-left: 1px solid ", ";\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n"])), getColor('fillBgSub'), getColor('shapeBorder'), getSize('typo14'), getColor('contentBody'));
export var SpeakingSettingsConfigComponent = function SpeakingSettingsConfigComponent(_ref3) {
  var states = _ref3.states,
      actions = _ref3.actions;
  var speakingSettings = states.speakingSettings,
      speakingSettingsLabel = states.speakingSettingsLabel,
      readonly = states.readonly;
  var onUpdateSpeakingSettings = actions.onUpdateSpeakingSettings,
      onSpeakingSettingsValidityChange = actions.onSpeakingSettingsValidityChange;
  var preparationTime = speakingSettings.preparationTime;
  var preparationTimeUnit = speakingSettings.preparationTimeUnit;
  var speakingTime = speakingSettings.speakingTime;
  var speakingTimeUnit = speakingSettings.speakingTimeUnit;
  var maxAttempts = speakingSettings.maxAttempts;
  var minAnswerDuration = speakingSettings.minAnswerDuration;
  var minAnswerDurationUnit = speakingSettings.minAnswerDurationUnit;

  var _useState = useState(preparationTime),
      preparationTimeInput = _useState[0],
      setPreparationTimeInput = _useState[1];

  var _useState2 = useState(speakingTime),
      speakingTimeInput = _useState2[0],
      setSpeakingTimeInput = _useState2[1];

  var _useState3 = useState(maxAttempts),
      maxAttemptsInput = _useState3[0],
      setMaxAttemptsInput = _useState3[1];

  var _useState4 = useState(minAnswerDuration),
      minAnswerDurationInput = _useState4[0],
      setMinAnswerDurationInput = _useState4[1];

  var isUnlimitedAttempts = SpeakingMaxAttempts.isUnlimited(maxAttempts);
  var isNoMinDuration = SpeakingMinAnswerDuration.isUnlimited(minAnswerDuration);
  useEffect(function () {
    setPreparationTimeInput(preparationTime);
  }, [preparationTime]);
  useEffect(function () {
    setSpeakingTimeInput(speakingTime);
  }, [speakingTime]);
  useEffect(function () {
    setMaxAttemptsInput(maxAttempts);
  }, [maxAttempts]);
  useEffect(function () {
    setMinAnswerDurationInput(minAnswerDuration);
  }, [minAnswerDuration]);
  var speakTimeSec = speakingTimeInput === '' ? 0 : TimeUnit.toTotalSeconds(speakingTimeInput, speakingTimeUnit);
  var minDurationSec = isNoMinDuration || minAnswerDurationInput === '' ? 0 : TimeUnit.toTotalSeconds(minAnswerDurationInput, minAnswerDurationUnit);
  var isMinDurationInvalid = !isNoMinDuration && minAnswerDurationInput !== '' && speakingTimeInput !== '' && minDurationSec >= speakTimeSec;
  var isValidForSave = useMemo(function () {
    return preparationTimeInput !== '' && preparationTimeInput >= 0 && speakingTimeInput !== '' && speakingTimeInput >= 0 && (isUnlimitedAttempts || maxAttemptsInput !== '' && maxAttemptsInput >= 1) && (isNoMinDuration || minAnswerDurationInput !== '' && minAnswerDurationInput >= 1) && !isMinDurationInvalid;
  }, [isMinDurationInvalid, isNoMinDuration, isUnlimitedAttempts, maxAttemptsInput, minAnswerDurationInput, preparationTimeInput, speakingTimeInput]);
  useEffect(function () {
    onSpeakingSettingsValidityChange === null || onSpeakingSettingsValidityChange === void 0 ? void 0 : onSpeakingSettingsValidityChange(isValidForSave);
  }, [isValidForSave, onSpeakingSettingsValidityChange]);

  var onPreparationTimeChange = function onPreparationTimeChange(value) {
    var nextValue = toNumberInputValue(value);
    setPreparationTimeInput(nextValue);
    if (nextValue !== '') onUpdateSpeakingSettings({
      preparationTime: nextValue
    });
  };

  var onPreparationTimeUnitChange = function onPreparationTimeUnitChange(value) {
    return onUpdateSpeakingSettings({
      preparationTimeUnit: value
    });
  };

  var onSpeakingTimeChange = function onSpeakingTimeChange(value) {
    var nextValue = toNumberInputValue(value);
    setSpeakingTimeInput(nextValue);
    if (nextValue !== '') onUpdateSpeakingSettings({
      speakingTime: nextValue
    });
  };

  var onSpeakingTimeUnitChange = function onSpeakingTimeUnitChange(value) {
    return onUpdateSpeakingSettings({
      speakingTimeUnit: value
    });
  };

  var onMaxAttemptsChange = function onMaxAttemptsChange(value) {
    var nextValue = toNumberInputValue(value);
    setMaxAttemptsInput(nextValue);

    if (nextValue !== '' && nextValue >= 1) {
      onUpdateSpeakingSettings({
        maxAttempts: nextValue
      });
    }
  };

  var onMinimumDurationChange = function onMinimumDurationChange(value) {
    var nextValue = toNumberInputValue(value);
    setMinAnswerDurationInput(nextValue);

    if (nextValue !== '' && nextValue >= 1) {
      onUpdateSpeakingSettings({
        minAnswerDuration: nextValue
      });
    }
  };

  var onMinimumDurationUnitChange = function onMinimumDurationUnitChange(value) {
    return onUpdateSpeakingSettings({
      minAnswerDurationUnit: value
    });
  };

  var handleToggleUnlimitedAttempts = function handleToggleUnlimitedAttempts(checked) {
    var nextValue = checked ? SpeakingMaxAttempts.Unlimited : SpeakingMaxAttempts.Default;
    setMaxAttemptsInput(nextValue);
    onUpdateSpeakingSettings({
      maxAttempts: nextValue
    });
  };

  var handleToggleNoMinDuration = function handleToggleNoMinDuration(checked) {
    var nextValue = checked ? SpeakingMinAnswerDuration.Unlimited : SpeakingMinAnswerDuration.Default;
    setMinAnswerDurationInput(nextValue);
    onUpdateSpeakingSettings({
      minAnswerDuration: nextValue
    });
  };

  var DEFAULT_SETTINGS_LABEL = {
    title: 'Cài đặt Speaking',
    preparationTime: 'Thời gian chuẩn bị',
    speakingTime: 'Thời gian trả lời',
    maxAttempts: 'Số lần thu âm',
    minAnswerDuration: 'Thời lượng tối thiểu mỗi câu',
    unlimited: 'Không giới hạn',
    noMinDuration: 'Không yêu cầu',
    noMinDurationPlaceholder: 'Không giới hạn tối thiểu',
    minDurationExceedsError: 'Thời lượng tối thiểu phải nhỏ hơn thời gian trả lời',
    times: 'lần',
    second: 'giây',
    minute: 'phút'
  };

  var resolvedLabel = _objectSpread(_objectSpread({}, DEFAULT_SETTINGS_LABEL), speakingSettingsLabel);

  var timesLabel = resolvedLabel.times;
  var secondLabel = resolvedLabel.second;
  var minuteLabel = resolvedLabel.minute;
  return /*#__PURE__*/_jsxs(StyledCard, {
    children: [/*#__PURE__*/_jsxs(StyledHeader, {
      children: [/*#__PURE__*/_jsx(Image, {
        src: "/icons/Microphone.svg",
        width: 20,
        height: 20,
        alt: "Microphone"
      }), /*#__PURE__*/_jsx(StyledTitle, {
        children: resolvedLabel.title.replace(/🎙\s*/, '')
      })]
    }), /*#__PURE__*/_jsxs(Row, {
      gutter: [16, 16],
      children: [/*#__PURE__*/_jsxs(Col, {
        span: 12,
        children: [/*#__PURE__*/_jsx(LabelRow, {
          children: /*#__PURE__*/_jsx(FieldLabel, {
            children: resolvedLabel.preparationTime
          })
        }), /*#__PURE__*/_jsxs(StyledInputGroup, {
          children: [/*#__PURE__*/_jsx(NumberInput, {
            min: 0,
            disabled: readonly,
            value: preparationTimeInput,
            onChange: onPreparationTimeChange
          }), /*#__PURE__*/_jsx(SingleSelectInput, {
            disabled: readonly,
            value: preparationTimeUnit,
            onChange: onPreparationTimeUnitChange,
            options: [{
              value: TimeUnit.Second,
              label: secondLabel
            }, {
              value: TimeUnit.Minute,
              label: minuteLabel
            }]
          })]
        })]
      }), /*#__PURE__*/_jsxs(Col, {
        span: 12,
        children: [/*#__PURE__*/_jsx(LabelRow, {
          children: /*#__PURE__*/_jsx(FieldLabel, {
            children: resolvedLabel.speakingTime
          })
        }), /*#__PURE__*/_jsxs(StyledInputGroup, {
          children: [/*#__PURE__*/_jsx(NumberInput, {
            min: 0,
            disabled: readonly,
            value: speakingTimeInput,
            onChange: onSpeakingTimeChange
          }), /*#__PURE__*/_jsx(SingleSelectInput, {
            disabled: readonly,
            value: speakingTimeUnit,
            onChange: onSpeakingTimeUnitChange,
            options: [{
              value: TimeUnit.Second,
              label: secondLabel
            }, {
              value: TimeUnit.Minute,
              label: minuteLabel
            }]
          })]
        })]
      }), /*#__PURE__*/_jsxs(Col, {
        span: 12,
        children: [/*#__PURE__*/_jsxs(LabelRow, {
          children: [/*#__PURE__*/_jsx(FieldLabel, {
            children: resolvedLabel.maxAttempts
          }), /*#__PURE__*/_jsxs(SwitchLabelWrapper, {
            children: [/*#__PURE__*/_jsx(Switch, {
              size: "small",
              checked: isUnlimitedAttempts,
              onChange: handleToggleUnlimitedAttempts,
              disabled: readonly
            }), /*#__PURE__*/_jsx("span", {
              children: resolvedLabel.unlimited
            })]
          })]
        }), isUnlimitedAttempts ? /*#__PURE__*/_jsx(DashedPlaceholderBox, {
          children: resolvedLabel.unlimited
        }) : /*#__PURE__*/_jsxs(StyledInputGroup, {
          children: [/*#__PURE__*/_jsx(NumberInput, {
            min: 1,
            disabled: readonly,
            value: maxAttemptsInput,
            onChange: onMaxAttemptsChange
          }), /*#__PURE__*/_jsx(StyledSuffixWrapper, {
            children: timesLabel
          })]
        })]
      }), /*#__PURE__*/_jsxs(Col, {
        span: 12,
        children: [/*#__PURE__*/_jsxs(LabelRow, {
          children: [/*#__PURE__*/_jsx(FieldLabel, {
            children: resolvedLabel.minAnswerDuration
          }), /*#__PURE__*/_jsxs(SwitchLabelWrapper, {
            children: [/*#__PURE__*/_jsx(Switch, {
              size: "small",
              checked: isNoMinDuration,
              onChange: handleToggleNoMinDuration,
              disabled: readonly
            }), /*#__PURE__*/_jsx("span", {
              children: resolvedLabel.noMinDuration
            })]
          })]
        }), isNoMinDuration ? /*#__PURE__*/_jsx(DashedPlaceholderBox, {
          children: resolvedLabel.noMinDurationPlaceholder
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(StyledInputGroup, {
            $error: isMinDurationInvalid,
            children: [/*#__PURE__*/_jsx(NumberInput, {
              min: 1,
              disabled: readonly,
              value: minAnswerDurationInput,
              onChange: onMinimumDurationChange
            }), /*#__PURE__*/_jsx(SingleSelectInput, {
              disabled: readonly,
              value: minAnswerDurationUnit,
              onChange: onMinimumDurationUnitChange,
              options: [{
                value: TimeUnit.Second,
                label: secondLabel
              }, {
                value: TimeUnit.Minute,
                label: minuteLabel
              }]
            })]
          }), isMinDurationInvalid && /*#__PURE__*/_jsx(StyledErrorMessage, {
            children: resolvedLabel.minDurationExceedsError
          })]
        })]
      })]
    })]
  });
};